module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "about"
    }
  }, [_c('h1', [_vm._v("Qui sommes-nous ?")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, _vm._l((_vm.$t('about.description')), function(p) {
    return _c('p', {
      domProps: {
        "innerHTML": _vm._s(p)
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "team"
  }, _vm._l((_vm.team), function(person) {
    return _c('a', {
      attrs: {
        "href": person.link,
        "target": "_blank"
      }
    }, [(person.slug) ? _c('img', {
      attrs: {
        "src": 'static/images/about/team/' + person.slug + '.jpg',
        "alt": ""
      }
    }) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    attrs: {
      "id": "plate"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3820e84!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 72
// module chunks = 1